import OwnerForm from "./OwnerForm";

export default OwnerForm;
